import React, { useEffect, useState } from "react";
import { LuCirclePlus } from "react-icons/lu";
import { Link, useNavigate } from "react-router-dom";
import ActionButtons from "../components/ActionButtons";
import { ImageLink, getData, updateData, deleteData } from "../services/axios.function";
import { toast } from "react-toastify";
import Loader from "../components/Loader";
import Pagination from "../components/Pagination";
import Fancybox from "../components/FancyBox";

const FestivalType = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [page, setPage] = useState(1);
  const limit = 10;
  const [totalPages, setTotalPages] = useState(1);

  const fetchFestivalTypeSection = async (currentPage = 1) => {
    try {
      setLoading(true);
      const response = await getData(
        `api/festival/pagination?page=${currentPage}&limit=${limit}`
      );
      if (response?.data?.isSuccess) {
        setData(response.data.data || []);
        setTotalPages(response.data.totalPages || 1);
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong!"
      );
    } finally {
      setLoading(false);
    }
  };


  const handleStatusToggle = async (id, isActive) => {
    try {
      const payload = {
        fieldId: id,
        isActive: !isActive,
        modelName: "FestivalType",
      };

      const response = await updateData(
        "api/user/update-status",
        payload
      );

      if (response?.data?.isSuccess) {
        setData((prevData) =>
          prevData.map((item) =>
            item._id === id
              ? { ...item, isActive: payload.isActive }
              : item
          )
        );

        toast.success(response.data.message);
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong!"
      );
    }
  };


  const deleteFestivalTypeImage = async (id) => {
    const response = await deleteData(
      `api/festival/delete/${id}`
    );
    if (response.status === 200) {
      toast.success(response.data.message);
      fetchFestivalTypeSection();
    }
  };

  const handleUpdate = async (data) => {
    navigate(`/add-festival-type`, {
      state: data,
    });
  };

  useEffect(() => {
    fetchFestivalTypeSection(page);
  }, [page]);

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="container-fluid">
      <div className="name-search-btn">
        <h4>Festival Types</h4>
        <div className="search-n-btn">
          {/* <div className="position-relative">
            <input type="text" placeholder="Search for Banner" className="custom-ip mt-0"/>
            <GoSearch size={16} className="search-icon"/>
          </div> */}
          <div className="add-btn">
            <Link to={`/add-festival-type`}>
              <button>
                <LuCirclePlus size={22} />
                Add Festival Type
              </button>
            </Link>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12 grid-margin stretch-card">
          <div className="card border-0">
            <div className="card-body">
              <div className="table-responsive border rounded p-1">
                <table className="table text-center">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Image</th>
                      <th>Name</th>
                      <th>isActive</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.length > 0 ? (
                      data?.map((item, index) => (
                        <tr key={item._id}>
                          <td>{item?.sortOrder}</td>
                          <td className="getImg">
                            <Fancybox>
                              <a
                                data-fancybox={index + 1}
                                href={ImageLink(item?.image)}
                                className="fancybox-link"
                              >
                                <img
                                  src={ImageLink(item?.image)}
                                  alt="Festival Type"
                                />
                              </a>
                            </Fancybox>
                          </td>
                          <td>{item.name}</td>

                          <td>
                            <label className="toggle-switch">
                              <input
                                type="checkbox"
                                name="isActive"
                                checked={item.isActive}
                                onChange={() => handleStatusToggle(item._id, item.isActive)}
                              />
                              <span className="slider" />
                            </label>
                          </td>
                          <td>
                            <div className="action-btn">
                              <ActionButtons
                                handleDelete={deleteFestivalTypeImage}
                                handleEdit={handleUpdate}
                                data={item}
                              />
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center py-4">
                          No Data Found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              {/* Add pagination here */}
              {totalPages > 1 && (
                <Pagination
                  pages={totalPages}
                  page={page}
                  onPageChange={(p) => setPage(p)}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FestivalType;
